import { Exam, User, ExamRoom } from "@types";

export type ExamPeriod = {
  id: string;
  externalId: any;
  user: User;
  exam: Exam;
  date: string;
  time: number;
  examRoom: ExamRoom;
  zoomMeetingId: string;
  zoomPasscode: string;
  participants: User[];
  userExaminees: User[];
  state: ExamPeriodState;
  contactId: string;
  contact: User;
  assessorId: string;
  assessor: User;
  monitoring: boolean;
  videoProctoringEnabled: boolean;
  safeExamBrowserEnabled: boolean;
};

export enum ExamPeriodState {
  Active = 1,
  InActive = 2,
  Deleted = 3,
  Activated = 4,
  InProgress = 5,
  Completed = 6,
  BeingActivated = 7,
  BeingDeactivated = 8,
}
